module.exports = __webpack_public_path__ + "img/logo.70e00ec4.png";